<template>
  <v-layout class="fill-height">
    <!-- Navigation -->
    <v-navigation-drawer
      v-model="drawer"
      app
      floating
      width="260"
      class="elevation-1"
      :right="$vuetify.rtl"
    >
      <!-- Navigation menu info -->
      <template v-slot:prepend>
        <div class="d-flex pa-2 align-center">
          <img src="/images/v-logo-small1.png" height="48" alt="logo" class="mr-1 brand-logo" />
        </div>
      </template>
      <div class="caption  text-center text-uppercase white--text pa-1">{{ portalType }} Portal</div>
      <div class="ma-1">
        <v-select
          v-model="selectedLOB"
          dense
          return-object
          :items="LOBoptions"
          item-text="text"
          item-value="id"
          label="Current Line Of Business"
          required
          outlined
          hide-details
          max-width="20px"
          @change="changeLOB"
        ></v-select>
      </div>
      <!-- Navigation menu -->
      <main-menu :menu="menu" />
      <v-divider class="my-1"></v-divider>
    </v-navigation-drawer>
    <v-system-bar app window class="system-bar d-flex d-sm-flex d-md-none">
      <v-row>
        <v-col class="text-center  white--text ">
          {{ companyName }}
        </v-col>
      </v-row>
    </v-system-bar>
    <!-- Toolbar -->
    <v-app-bar app flat color="surface">
      <v-card class="flex-grow-1 d-flex pa-1 mt-5 mx-1 secondary">
        <div class="d-flex flex-grow-1 align-center">
          <div class="d-flex flex-grow-1 align-center">
            <v-app-bar-nav-icon class="d-lg-none" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
            <div class="d-none d-md-flex  text-uppercase white--text">
              <h3> {{ companyName }}</h3>
            </div>
            <v-spacer class=""></v-spacer>
            <v-spacer class="d-block d-sm-none"></v-spacer>
            <div :class="[$vuetify.rtl ? 'ml-1' : 'mr-1']">
              <toolbar-notifications />
            </div>

            <toolbar-user />
          </div>
        </div>
      </v-card>
    </v-app-bar>

    <v-container fluid class="pt-3">
      <router-view class="py-2 fill-height"></router-view>

      <!-- DEMO PURPOSES DEFAULT ROUTER VIEW -->
      <div v-if="isDemo" class="py-2 fill-height">
        <slot></slot>
      </div>
    </v-container>
    <v-snackbar v-model="snackbar" right>
      {{ snackbartext }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-layout>
</template>

<script>
import config from '@/configs'
import MainMenu from '../menus/MainMenu'
import ToolbarUser from '../toolbars/ToolbarUser'
import ToolbarNotifications from '../toolbars/ToolbarNotifications'

import httpServ from '@/services/HTTPService'
import menu from '../menus/menu'
import mainMemberMenu from '../menus/mainMemberMenu'
import firstrunMenu from '../menus/firstrunMenu'
import mainDistributorMenu from '../menus/mainDistributorMenu'
import mainProducerMenu from '../menus/mainProducerMenu'

export default {
  components: {
    MainMenu,
    ToolbarUser,
    ToolbarNotifications
  },
  props: {
    isDemo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      portalType: '',
      mainMenuType: '',
      companyName: '',
      currentLOBDetails: {},
      memberStatus: '',
      mainMemberMenu,
      firstrunMenu,
      mainDistributorMenu,
      mainProducerMenu,
      menu,
      LOBoptions: [],
      selectedLOB: 'main_line_of_business',
      config,
      drawer: null,

      showSearch: false,
      businessLineId: '',
      select: null,

      switchItems: [],
      userProfile: '',
      snackbar: false,
      snackbartext: '',

      //websocket data
      socket: null,
      clientId: '',
      isConnected: false,
      statusMessage: 'Disconnected',
      messageText: '',
      logs: [],
      reconnectAttempts: 0,
      maxReconnectAttempts: 15,
      reconnectionWindow: 20000, //Wait this number of seconds before trying again
      reconnectTimeout: null
    }
  },
  created() {
    this.memberData = httpServ.getSessionJson('memberData')
    this.companyName = this.memberData.company_name
    this.portalType = this.memberData.lobs[this.selectedLOB].membership_status
    this.changeMenu()
    this.currentLOBDetails = this.memberData.lobs[this.memberData.displayLOB]
    this.LOBoptions.push({
      text: this.memberData.lobs['main_line_of_business'].line_of_business_name,
      id: 'main_line_of_business'
    })
    if (this.memberData.lobs['second_line_of_business'].line_of_business_id > 0) {
      this.LOBoptions.push({
        text: this.memberData.lobs['second_line_of_business'].line_of_business_name,
        id: 'second_line_of_business'
      })
    }
    this.selectedLOB = this.memberData.displayLOB
    //console.log(this.memberData.lobs[this.selectedLOB].line_of_business_id)
    this.changeMenu()

    this.clientId = this.memberData.membership_id
    try {
      this.connectWebSocket()
      //setTimeout(() => this.connectWebSocket(), 20000)
    } catch (err) {
      console.error('WebSocket error:', err)
    }
  },
  beforeDestroy() {
    try {
      this.disconnectWebSocket()
      if (this.reconnectTimeout) {
        clearTimeout(this.reconnectTimeout)
      }
    } catch (err) {
      console.error('WebSocket error:', err)
    }
    
  },
  methods: {
    changeMenu: function () {
      //console.log('change menu called')
      if (this.portalType === 'Firstrun') {
        this.menu = this.firstrunMenu
      } else {
        //this.menu = this.mainMemberMenu 
        if (parseInt(this.memberData.lobs[this.selectedLOB].line_of_business_id) === 1) {
          this.menu = this.mainDistributorMenu
        } else {
          this.menu = this.mainProducerMenu
        }

      }
    },
    changeLOB: function () {
      this.snackbartext = 'Switching current line of business'
      this.snackbar = true
      this.memberData.displayLOB = this.selectedLOB.id
      this.memberData = httpServ.getSessionJson('memberData')
      this.memberData.displayLOB = this.selectedLOB.id
      httpServ.setSessionJson('memberData', this.memberData)

      setTimeout(() => {
        if (this.$route.name === 'dashboard') {
          this.$router.push({ name: 'dummyDashboard' })
        } else {
          this.$router.push({ name: 'dashboard' })
        }
      }, 3000)
    },
    connectWebSocket() {
      //console.log('Making a websocket connection.')

      if (!this.clientId.trim()) {
        this.logMessage('System Error: Client ID cannot be blank.')
        console.log('System Error: Client ID cannot be blank.')

        return
      }

      const NOTICE_BASE_URL = process.env.VUE_APP_WEBSOCKET_API_BASE_URL || 'localhost:8000'
      const protocol = window.location.protocol === 'https:' ? 'wss://' : 'ws://'
      const url = protocol + NOTICE_BASE_URL + '/?clientId=' + encodeURIComponent(this.clientId.trim())

      this.statusMessage = 'Initiating handshake...'
      //const serverUrl = `ws://localhost:8080/?clientId=${encodeURIComponent(this.clientId.trim())}`

      this.socket = new WebSocket(url)

      // Triggered only if handshake succeeds (Server returns HTTP 101)
      this.socket.onopen = () => {
        this.isConnected = true
        this.reconnectAttempts = 0
        this.statusMessage = 'Connected (Handshake Accepted)'
        this.logMessage(`System: Securely registered as [${this.clientId}]`)

      }

      this.socket.onmessage = (event) => {
        this.logMessage(`From Server: ${event.data}`)
        this.snackbartext = event.data
        this.snackbar = true
      }

      // Triggered if connection closes OR if handshake is rejected (Server returns HTTP 400/409)
      this.socket.onclose = (event) => {
        const wasConnected = this.isConnected

        this.isConnected = false
        this.socket = null

        if (wasConnected) {
          this.statusMessage = 'Disconnected'
          this.logMessage('System: Connection closed cleanly by remote host.')

        } else {
          // If connection fails before onopen, the handshake was likely rejected
          this.statusMessage = 'Handshake Rejected'
          this.logMessage(`System Error: Handshake blocked by Vert.x server (Code: ${event.code}). Verification failed.`)
          this.attemptReconnect()
        }
      }
      this.socket.onerror = (error) => {
        this.logMessage('Network Error: Unable to establish socket pipe.')
        console.error('Socket context details:', error)
      }
    },
    attemptReconnect() {
      if (this.reconnectAttempts < this.maxReconnectAttempts) {
        this.reconnectAttempts++
        this.statusMessage = `Reconnecting (${this.reconnectAttempts}/${this.maxReconnectAttempts})...`

        this.reconnectTimeout = setTimeout(() => {
          this.connectWebSocket()
        }, this.reconnectionWindow) // Wait 3 seconds before trying again
      } else {
        this.statusMessage = 'Connection Failed Permanently'
        this.logMessage('System: Max structural reconnection thresholds breached. Stopping retry loop.')
      }
    },
    disconnectWebSocket() {
      if (this.socket) {
        this.socket.close()
      }
      this.reconnectAttempts = this.maxReconnectAttempts // Stop reconnect loops
      this.statusMessage = 'Disconnected'
    },
    logMessage(text) {
      const time = new Date().toLocaleTimeString()

      console.log(text)

      this.logs.unshift(`[${time}] ${text}`) // Show newest log first

    },

    sendMessage() {
      if (!this.messageText.trim() || !this.isConnected) return

      this.socket.send(this.messageText)
      this.logMessage(`Sent: ${this.messageText}`)
      this.messageText = ''
    }
  }
}
</script>
<style scoped>
.select .v-input__slot {
  padding-right: 10px;
  max-width: 30px;
}

.lob-bg {
  background-color: #0a6003 !important;
}

.lob-option {
  background-color: #49e80f !important;
}

.font-small {
  font-size: 13px !important;
}

.current-bus-line {
  text-align: right !important;
  font-size: 16px !important;
  font-weight: bold !important;
  color: white !important;
}

.system-bar {
  background-color: #8b8988 !important;
}

.system-bar select {
  background-color: white !important;
}

.elevation-1 {
  background-color: #a5d6a7 !important;
}

.app-title {
  font-size: 30px;
}

.brand-logo {
  width: 240px !important;
  height: 30px !important;
}

.top-switch {
  background-color: black !important;
}

h1,
h2,
h3,
h4,
h5,
h6,
.text-h4,
.text-h1,
.text-h2,
.text-h3,
.text-h4,
.text-h5,
.text-h6 {
  font-weight: 400 !important;
}
</style>